import React from "react"
import FavoriteIntern from "./components/favoriteIntern/FavoriteIntern"
import Testimonial from "./components/testimonial/Testimonial"
import { image } from "../../assets/images"
import { LandingWrapp } from "./Landing.style"
import { Link } from "react-router-dom"

const Landing = () => {
  return (
    <LandingWrapp>
      <div className="background-color">
        <div className="container">
          <div className="landing">
            <div data-aos="fade-right" className="left">
              <div className="content">
                <h1 className="title">Find Your Perfect Internship at <span>KarirKu</span></h1>
                <p className="desc">Not sure which field suits you best?
                  Discover your ideal career path with our AI-powered assessment.</p>
                <div className="section">
                  <button><Link to="/karir" className="link-btn">Get Started</Link></button>
                </div>
              </div>
            </div>
            <div className="right">
              <div className="background-image">
                <div className="image">
                  <img src={image.image_ilustration} alt='career_illustration' />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <FavoriteIntern />
      <Testimonial />
    </LandingWrapp>
  )
}

export default Landing
